import { ListAgreedTerms } from 'domain/usecases/user/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
  Conflict,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteListAgreedTerms implements ListAgreedTerms {
  private readonly url: string;

  private readonly httpClient: HttpClient<ListAgreedTerms.Model>;

  constructor(url: string, httClient: HttpClient<ListAgreedTerms.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  list = async (
    params: ListAgreedTerms.Params,
  ): Promise<ListAgreedTerms.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{userId}', `${params.userId}`),
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      case HttpStatusCode.conflict:
        throw new Conflict();
      default:
        throw new UnexpectedError();
    }
  };
}
